function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"],
  _excluded2 = ["scope", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// packages/react/context/src/createContext.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
function createContext2(rootComponentName, defaultContext) {
  var Context = /*#__PURE__*/React.createContext(defaultContext);
  function Provider(props) {
    var children = props.children,
      context = _objectWithoutProperties(props, _excluded);
    var value = React.useMemo(function () {
      return context;
    }, Object.values(context));
    return /* @__PURE__ */jsx(Context.Provider, {
      value: value,
      children: children
    });
  }
  function useContext2(consumerName) {
    var context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext2];
}
function createContextScope(scopeName) {
  var createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    var BaseContext = /*#__PURE__*/React.createContext(defaultContext);
    var index = defaultContexts.length;
    defaultContexts = [].concat(_toConsumableArray(defaultContexts), [defaultContext]);
    function Provider(props) {
      var scope = props.scope,
        children = props.children,
        context = _objectWithoutProperties(props, _excluded2);
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var value = React.useMemo(function () {
        return context;
      }, Object.values(context));
      return /* @__PURE__ */jsx(Context.Provider, {
        value: value,
        children: children
      });
    }
    function useContext2(consumerName, scope) {
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext2];
  }
  var createScope = function createScope() {
    var scopeContexts = defaultContexts.map(function (defaultContext) {
      return /*#__PURE__*/React.createContext(defaultContext);
    });
    return function useScope(scope) {
      var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(scopeName), _objectSpread(_objectSpread({}, scope), {}, _defineProperty({}, scopeName, contexts)));
      }, [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes.apply(void 0, [createScope].concat(_toConsumableArray(createContextScopeDeps)))];
}
function composeContextScopes() {
  for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
    scopes[_key] = arguments[_key];
  }
  var baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  var createScope = function createScope() {
    var scopeHooks = scopes.map(function (createScope2) {
      return {
        useScope: createScope2(),
        scopeName: createScope2.scopeName
      };
    });
    return function useComposedScopes(overrideScopes) {
      var nextScopes = scopeHooks.reduce(function (nextScopes2, _ref2) {
        var useScope = _ref2.useScope,
          scopeName = _ref2.scopeName;
        var scopeProps = useScope(overrideScopes);
        var currentScope = scopeProps["__scope".concat(scopeName)];
        return _objectSpread(_objectSpread({}, nextScopes2), currentScope);
      }, {});
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(baseScope.scopeName), nextScopes);
      }, [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
export { createContext2 as createContext, createContextScope };